// extracted by mini-css-extract-plugin
module.exports = {"navButtons":"AdacCallbackOptionsPage_navButtons__mC8S5"};